import { useQuery } from "@tanstack/react-query";
import api from "@/config/axiosConfig";
import { Location, LocationUpdate } from "@/types";
import useTrip from "@/stores/tripBuilder/useTrip";

export function useLocationUpdates(location: Location | null) {
  const { tripData, isParticipant } = useTrip();
  return useQuery({
    queryKey: [
      "locationUpdates",
      location?.id,
      location?.waytora_id,
      tripData?.id,
    ],
    queryFn: async () => {
      if (!location || !tripData) return [];
      const response = await api.social.get(`/location-updates`, {
        params: {
          waytoraId: location.waytora_id,
          tripId: tripData?.id,
          locationId: location.id,
          limit: 10,
        },
      });
      return response.data as LocationUpdate[];
    },
    enabled: !!location && !!tripData && isParticipant,
    refetchOnWindowFocus: true,
  });
}
